import * as React from "react";
import * as SwitchPrimitive from "radix-ui/switch";
import { cn } from "@/lib/utils";

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitive.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitive.Root
    ref={ref}
    data-slot="switch"
    className={cn(
      "peer inline-flex h-[18px] w-8 shrink-0 items-center rounded-full border border-transparent transition-colors outline-none focus-visible:ring-[3px] focus-visible:ring-ring/40 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-grey-300",
      className
    )}
    {...props}
  >
    {/* The thumb is the paper colour, not white: white on grey-300 vanishes in dark. */}
    <SwitchPrimitive.Thumb className="pointer-events-none block size-[14px] rounded-full bg-card shadow-xs transition-transform data-[state=checked]:translate-x-[15px] data-[state=unchecked]:translate-x-px" />
  </SwitchPrimitive.Root>
));
Switch.displayName = "Switch";

export { Switch };
